module.exports = "# Esmeralda and Goober Intro\n\nYouTube: BSMdUUViT94\n\n## Notes\nIan and Sara introduce the Esmeralda and Goober storyline (0:42).\n\n# Esmeralda and Goober Story\n\nYouTube: vY9c9oatHDw\n\n## Notes\nEsmeralda and Goober storyline - Know the Risks (3:43).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsIntermediates/sections/11_esGooberStory/level1_egstory.md
// module id = 1598
// module chunks = 2